export default __webpack_public_path__ + "static/media/rocket_anim_146.dcfa9f93.png";